import { IInventoryPage } from '../../../inventory-page.interface';


export const RESEARCH_RESEARCH_SELLER_TRENDS_PAGE: IInventoryPage = {
	'route': '/research/research/seller-trends',
	'title': 'Seller Trends',
	'uiReference': [
		'Search Seller Trends',
		'Open in Amazon',
		'Open search options',
		'Search',
		'Search options',
		'Choose how results should be matched.',
		'Specific search Prioritize an exact keyword match.',
		'Title only Limit matches to listing titles.',
		'Marketplace',
		'Product',
		'Sorting',
		'Advanced Options',
		'Advanced filters',
		'Reset filters',
		'Time period',
		'Show trend types',
		'BSR range',
		'Trends Winner (%)',
		'Trends Winner (BSR)',
		'Trends Loser (%)',
		'Trends Loser (BSR)',
		'BSR',
		'Newest',
		'Oldest',
		'Random',
		'Designs of all trend types will be shown: Winners, Losers, Defenders, Newcomers.',
		'Winners - are designs which have improved their BSR (the rank decreased) over the given time period.',
		'Losers - are designs which have worsened their BSR (the rank increased) over the given time period.',
		'Defenders - are designs which have maintained their BSR (the rank has nor improved or worsen based on the threshold) over the given time period.',
		'Newcomers - are designs which had no BSR before the given time period or have improved their BSR from over 5.000.000.',
		'Copy all ASINs',
		'ASIN Board',
		'Copy All ASINS',
		'Remove from favorites',
		'Enter a tag',
		'Favorite tag',
		'Generate image using AI',
		'NEW',
		'History Rank :',
		'History Price : NA',
		'Removed',
		'ASIN',
		'review(s)',
		'Published since',
		'Saved',
		'Update tag',
		'Show BSR categories',
		'Show estimated sales history',
		'Show price history',
		'Open design details',
		'Platform:',
		'Category:',
		'ASIN :',
		'N/A',
		'Sales',
		'Price',
		'Reviews',
		'Bulletpoints and Description',
		'View design',
		'&pound;',
		'&euro;',
		'Loading...',
		'Sorry, there was an internal error. Please contact support.',
		'Oh man, the board seems to be not included in the free version',
		'Open in KW Workbench',
		'Copy to Clipboard'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/research-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/seller-trends/seller-trends.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/seller-trends/seller-trends.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/seller-trends/seller-trends.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/research-results-toolbar/research-results-toolbar.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/research-results-toolbar/research-results-toolbar.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-views/mba-design-view/mba-design-view.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-views/mba-design-view/mba-design-view.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba/design-mba.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba/design-mba.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba-detail/design-mba-detail.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba-detail/design-mba-detail.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-board/kw-board.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-board/kw-board.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/trends-badge/trends-badge.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/trends-badge/trends-badge.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/add-to-favorite/add-to-favorite.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/add-to-favorite/add-to-favorite.component.html'
	],
	'aliases': []
};
